module.exports = __webpack_public_path__ + "img/carte_Footer_manitou.258bc486.svg";